import React, { Component } from 'react';

export default class extends Component {
    render() {
        return (
            <div className="ModalHeader" >
                <div>{this.props.header}</div>
                <span >{this.props.subHeader}</span>
                <p className="f_12 clr-dark-gray" >{this.props.subText}</p>
            </div>

        );
    }
}
